export enum REPORT_STATUS_IDS {
     startProgress  = 1,
     underEvaluation =2,
     confirmFindings = 3,
     inProgress = 4,
     closed = 5,
     cancelled = 6
}
